module.exports = __webpack_public_path__ + "img/maison24.16f765c6.jpg";